import { loadModules } from 'esri-loader';

const BSLASearchWidget = async (view: __esri.View) => {
    type searchModeules = [
        typeof import('esri/widgets/Search'),
        typeof import('esri/widgets/Search/LocatorSearchSource'),
        typeof import('esri/tasks/Locator'),
        typeof import('esri/geometry/Extent')
    ];

    const [Search, LocatorSearchSource, Locator, Extent] = await (loadModules([
        'esri/widgets/Search',
        'esri/widgets/Search/LocatorSearchSource',
        'esri/tasks/Locator',
        'esri/geometry/Extent'
    ]) as Promise<searchModeules>);

    const search = new Search({
        view,
        includeDefaultSources: false,
        allPlaceholder: 'Search'
    });

    const geocoderSource = new LocatorSearchSource({
        countryCode: 'US',
        name: 'Search Addresses',
        placeholder: 'Search Addresses',
        filter: {
            geometry: new Extent({
                xmin: -9987567.863851676,
                ymin: 2781055.2453008024,
                xmax: -8398900.667972995,
                ymax: 3709306.516795736,
                spatialReference: { wkid: 102100 }
            })
        },
        locator: new Locator({
            url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer'
        })
    });

    search.sources.add(geocoderSource);

    return search;
};

export default BSLASearchWidget;
